export const getCollaboratorsWorkCenterInitialState = {
	collaborators: null,
	error: null,
	errorShow: false,
	loading: false,
};
